import {
  QuestReportWorkOrderCostRequest,
  QuestWorkOrderAdministrativeReportRequest,
  QuestWorkOrderTotalPerWorkOrderRequest,
} from './WorkOrder.types';
import { API_BASE_URL } from '..';
import { publicInstance } from '@/api/axiosInstance';
import api from '@/api';

const CONTROLLER_URL = `${API_BASE_URL}/WorkOrder`;

export async function getQuestReportWorkOrderAdministrativeReport(
  params: QuestWorkOrderAdministrativeReportRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/AdministrativeReport`,
    params,
  )) as unknown;

  return result as BlobPart;
}

export async function getReportWorkOrderAdministrativePublic(params: {
  token: string;
}) {
  const result = await publicInstance.get<BlobPart>(
    `${CONTROLLER_URL}/PublicAdministrativeReport`,
    { params, responseType: 'arraybuffer' },
  );

  return result.data;
}

export async function getQuestReportWorkOrderCost(
  params: QuestReportWorkOrderCostRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/WorkOrderCostReport`,
    params,
  )) as unknown;

  return result as BlobPart;
}

export async function getQuestReportWorkOrderWorkshop({
  complementId,
  header,
}: {
  complementId: number;
  header?: boolean;
}) {
  const result = (await api.getReport(`${CONTROLLER_URL}/WorkshopReport`, {
    complementId,
    header,
  })) as unknown;

  return result as BlobPart;
}

export async function getQuestReportWorkOrderTotalPerWorkOrder(
  params: QuestWorkOrderTotalPerWorkOrderRequest,
) {
  const result = await publicInstance.get<BlobPart>(
    `${CONTROLLER_URL}/TotalPerWorkOrder`,
    { params, responseType: 'arraybuffer' },
  );

  return result.data;
}

export async function getQuestReportWorkOrderPermanenceDeclaration(
  complementId: number,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/PermanenceDeclaration`,
    {
      complementId,
    },
  )) as unknown;

  return result as BlobPart;
}
